import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"


import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaContacto: new Date(),
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.contactos.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Contacto"}
                buttonTitle={"Ver Contacto"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>

                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Fecha de Contacto</Label>
                    </Col>
                    <Col className="col-8">
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'fechaContacto', disabled: true }}
                            value={this.state.fechaContacto}
                            onChange={(e) => this.setState({ fechaContacto: e._d })}
                        />
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Empresa/Organización</Label>
                    </Col>
                    <Col className="col-8">
                        <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Email</Label>
                    </Col>
                    <Col className="col-8">
                        <Input type="text" name="email" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                    </Col>
                    <Col className="col-8">
                        <Input type="text" name="telefono" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input rows={10} type="textarea" name="observaciones" disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-4">
                        <Label>Creado por</Label>
                    </Col>
                    <Col className="col-8">
                        <Input disabled={true} type="text" name="user" />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento0/Detail.js